module.exports = __webpack_public_path__ + "img/csr_032423_C.62c5d3a8.jpg";